export interface PersonalInfoFormValues {
    dob: any;
    gender: string;
    nationality: string;
    bloodGroup: string;
}
